import { darken } from "polished";
import styled from "styled-components";
import InputCustom from "../../components/InputCustom";

export const CheckoutPage = styled.div`
  /* height: calc(100vh - 291px); */
  overflow-y: visible;
  @media (max-width: 1368px) {
    height: auto;
  }
`;

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  /* padding: 0 40px; */
  margin-top: 10px;
  margin-bottom: 25px;

  @media (max-width: 1000px) {
    flex-direction: column;
    padding: 0 20px;
  }

  @media (max-width: 400px) {
    padding: 15px;
    padding-top: 0px;
  }
`;

export const StoreItem = styled.div`
  padding: 24px;
  width: 100%;
  min-height: 170px;
  background: #ffffff;
  box-shadow: 1px 3px 5px rgba(0, 0, 0, 0.04);
  display: flex;
  align-items: center;
  border: 1px solid
    ${(props) => (props.selected ? props.theme.colors.secondary : "#ECECEC")};
  transition: 100ms ease-in-out;

  div.store-info {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  div.store-address-info p {
    color: #666;
    margin-top: 8px;
  }

  div.delivery-time-info {
    display: flex;
    flex-direction: column;
    margin-top: 16px;

    span.label-time-info {
      color: #666;
      font-weight: 400;
      font-size: 14px;
    }

    span.titulo {
      color: ${(props) => props.theme.colors.headingLight};
      font-weight: bold;
    }

    strong {
      font-weight: 600;
      color: #666;
      margin-top: 4px;
      font-size: 16px;
    }

    span.withdrawal-time {
      margin-top: 12px;
      color: #57b85b;
      font-weight: 400;

      strong {
        font-weight: 600;
        color: #57b85b;
      }
    }
  }

  strong {
    font-size: 1.6rem;
    line-height: 18px;
    color: ${(props) =>
      props.selected
        ? props.theme.colors.secondary
        : props.theme.colors.primary};
  }
`;

export const ErrorContainer = styled.div`
  width: calc(100% - 32px);
  max-width: 1200px;
  background: rgba(222, 22, 22, 0.08);
  border: 1px solid ${(props) => props.theme.colors.error};
  color: ${(props) => props.theme.colors.error};
  font-size: 1.6rem;
  font-family: 'DM Sans', system-ui, sans-serif;
  border-radius: 12px;
  display: flex;
  margin: 25px auto 10px auto;
  align-items: center;
  padding: 10px 16px;
  min-height: 50px;
`;

export const FieldErrorMessage = styled.div`
  color: ${(props) => props.theme.colors.warning};
  font-size: 12px;
  margin-top: 5px;
  font-family: 'DM Sans', system-ui, sans-serif;
`;

export const CouponErrorMessage = styled.div`
  color: ${props => props.theme.colors.error};
  font-size: 14px;
  align-self: flex-start;
`;

export const CreditCard = styled.section`
  display: flex;
  max-width: 384px;
  width: 100%;
  margin-top: 24px;
  margin-bottom: 18px;

  > div {
    width: 384px;
    height: 225px;
    @media (max-width: 496px) {
      width: 100%;
    }
  }

  > div > div {
    width: 384px;
    height: 225px;
    @media (max-width: 496px) {
      width: 100%;
    }
  }
  .rccs__card--unknown > div {
    background: linear-gradient(25deg, #143c97, #08183c);
  }
`;

export const InputField = styled.input`
  height: 45px;
  background: #ffffff;
  border: 1px solid
    ${(props) => (props.invalid ? props.theme.colors.warning : props.theme.colors.neutral200)};
  box-sizing: border-box;
  padding-left: 10px;
  font-size: 16px;
  outline: none;
  transition: all 0.3s ease;
  -webkit-appearance: none;
  border-radius: 8px;

  + label {
    font-weight: 700;
    color: ${(props) =>
      props.invalid
        ? props.theme.colors.warning
        : props.theme.colors.neutral900};
  }

  :focus {
    border: 1px solid
      ${(props) =>
        props.invalid
          ? props.theme.colors.warning
          : props.theme.colors.primary};
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    font-weight: 700;
  }

  :focus + label {
    font-weight: 700;
    color: ${(props) =>
      props.invalid
        ? props.theme.colors.warning
        : props.theme.colors.primary};
  }

  ::placeholder {
    color: ${(props) => props.theme.colors.bodyLight};
  }

  :disabled {
    background: ${(props) => props.theme.colors.neutral50};
  }

  @media (max-width: 1000px) {
  }
`;

export const Tabs = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #e8e8e8;
  margin: 20px 0;
`;

export const Image = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  height: 30px;
  width: 100%;
  margin: 0 auto;
  cursor: pointer;

  :hover {
    text-decoration: underline;
  }

  img {
    object-fit: contain;
    width: 30px;
    height: 30px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    cursor: pointer;
  }

  span {
    color: ${(props) => props.theme.colors.neutral600};
    font-weight: bold;
    font-size: 16px;
    height: 100%;
    width: 150px;
    text-align: center;
    transition: color .2s ease;
  }

  span.selected {
    color: ${(props) => props.theme.colors.neutral900};
    border-bottom: solid 3px ${(props) => props.theme.colors.primary};
  }
`;

export const RadioConteinerGroup = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 1.6rem;
  align-items: center;
  padding-top: 10px;
  width: 100%;

  & > div {
    display: flex;
    width: 100%;
  }

  span {
    font-size: 16px;
    font-weight: 500;
    color: ${(props) => props.theme.colors.neutral900};
    padding-left: 34px;
    display:none;
  }

  .textLine {
    display: flex;
    gap: 24px;
    padding-left: 34px;
    width: 100%;
    align-items: end;

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 0px;
    }
  }

  .textArea {
    display: flex;
    flex-direction: column;
    margin-top: 16px;
    width: 100%;

    input {
      margin-left: 0px;
      width: 100%;
    }

    span {
      font-size: 12px;
      font-weight: 700;
      color: ${(props) => props.theme.colors.neutral900};
      padding-left: 0;
    }
  }

  input {
    font-size: 16px;
    height: 53px;
  }

  .radio {
    flex-direction: column;
    display: flex;
    padding: 20px;
    align-items: flex-start;
    border-radius: 16px;
    border: 1px solid var(--neutral-100, #e8e8e9);
    width: 100%;
    font-weight: bold;
    margin-bottom: 12px;
    line-height: 26.5px;
    transition: border-color .2s ease, background .2s ease;

    :hover {
      border-color: ${(props) => props.theme.colors.primary};
    }

    .radio-label {
      display: flex;
      align-items: center;
      gap: 12px;
      color: var(--neutral-900, #151922);
      font-family: 'DM Sans', system-ui, sans-serif;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      margin-top: 6px;
    }

    input[type="radio"] {
      position: absolute;
      opacity: 0;
      + .radio-label {
        &:before {
          content: "";
          background: #fff;
          border-radius: 100%;
          border: 1px solid ${(props) => props.theme.colors.neutral200};
          display: inline-block;
          width: 17px;
          height: 17px;
          position: relative;
          vertical-align: top;
          cursor: pointer;
          text-align: center;
          transition: all 250ms ease;
        }
      }
      &:checked {
        + .radio-label {
          &:before {
            background-color: ${(props) => props.theme.colors.primary};
            box-shadow: inset 0 0 0 2.5px #f4f4f4;
            border: 1px solid ${(props) => props.theme.colors.primary};
          }
        }
      }
      &:focus {
        + .radio-label {
          &:before {
            outline: none;
            border-color: ${(props) => props.theme.colors.primary};
          }
        }
      }
      &:disabled {
        + .radio-label {
          &:before {
            box-shadow: inset 0 0 0 2.5px #f4f4f4;
            border-color: ${darken(0.25, "#f4f4f4")};
            background: ${darken(0.25, "#f4f4f4")};
          }
        }
      }
      + .radio-label {
        &:empty {
          &:before {
            margin-right: 0;
          }
        }
      }
    }
  }

  .selected {
    border: 1px solid ${(props) => props.theme.colors.primary};
    background: ${(props) => props.theme.colors.primary40};
  }
`;

export const IconBadge = styled.div`
    display: flex;
    flex-shrink: 0;
    width: 44px;
    height: 44px;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    background: ${(props) => props.theme.colors.primary40};
    color: ${(props) => props.theme.colors.primary};
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column-reverse;
  justify-content: flex-end;
  width: 384px;
  margin: 10px 0;

  .combobox {
    label {
      color: ${(props) => props.theme.colors.neutral900};
      font-weight: 700;
    }
    > div {
      height: 53px !important;
      border-radius: 8px;
    }
  }

  .segundaCol {
    margin-left: 20px;
  }

  @media (max-width: 760px) {
    width: 100%;
    .segundaCol {
      margin-left: 0;
    }
  }
`;

export const Label = styled.label`
  transition: all 0.3s ease;
  font-family: 'DM Sans', system-ui, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  color: ${(props) => props.theme.colors.neutral900};
`;

export const Form = styled.form`
  overflow: auto;
  width: 100%;
  max-width: 900px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .pag-card {
    min-height: 650px;
    width: 100%;
    background: ${(props) => props.theme.colors.neutral50};
    border-radius: 16px;
    padding: 24px;
    margin-top: 16px;

    .cardGroup {
      display: flex;
      @media (max-width: 760px) {
        flex-direction: column;
        width: 100%;
      }
    }

    .menorCampo {
      width: 180px;
      @media (max-width: 760px) {
        width: 100%;
      }
    }

    @media (max-width: 760px) {
      min-height: 850px;
      padding: 16px;
    }
  }

  .pag-local {
    min-height: 650px;
    width: 100%;
    .cardGroup {
      display: flex;
      @media (max-width: 760px) {
        flex-direction: column;
        width: 100%;
      }
    }

    .menorCampo {
      width: 180px;
      @media (max-width: 760px) {
        width: 100%;
      }
    }
  }

  h1 {
    font-family: 'Sora', system-ui, sans-serif;
    font-size: 16px;
    font-weight: 700;
    color: ${(props) => props.theme.colors.neutral900};
    margin: 0 0 16px;
  }

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
    padding: 0;
  }
`;

export const PaymentDetails = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;

  h1 {
    color: ${(props) => props.theme.colors.neutral900};
    font-family: 'Sora', system-ui, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin: 0 0 16px;
  }
`;

export const DivBadgeStyled = styled.div`
  margin-top: 10px;
`;

export const OrderDetails = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 30px;

  @media (max-width: 1000px) {
    align-items: center;
    margin: 0;
    padding: 0;
  }

  h1 {
    color: ${(props) => props.theme.colors.headingLight};
    font-size: 1.8rem;
    font-weight: 500;
    display: flex;
    align-self: flex-start;
    padding: 10px 0;
  }
`;

export const PaymentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.neutral100};
  border-radius: 16px;
  box-shadow: var(--cards);
  padding: 24px;
  margin: 5px 0;

  @media (max-width: 1000px) {
    max-width: 100%;
    padding: 16px;
  }

  h3 {
    padding: 5px 0;
    color: ${(props) => props.theme.colors.headingLight};
    font-size: 1.6rem;
    font-weight: 500;
  }

  a {
    color: ${(props) => props.theme.colors.primary};
    font-size: 1.6rem;
    cursor: pointer;
    text-decoration: underline;

    strong {
      font-weight: 500;
    }
  }
`;

export const Item = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 10px;
  padding-left: 35px;
  padding-right: 35px;
  margin: 5px 0;
  background: #fff;

  @media (max-width: 1000px) {
    max-width: 100%;
  }

  h3 {
    padding: 5px 0;
    color: ${(props) => props.theme.colors.headingLight};
    font-size: 1.6rem;
    font-weight: 500;
  }

  a {
    color: ${(props) => props.theme.colors.primary};
    font-size: 1.6rem;
    cursor: pointer;
    text-decoration: underline;

    strong {
      font-weight: 500;
    }
  }
`;

export const Address = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 20px;
  padding-left: 35px;
  margin: 5px 0;
  background: #fff;

  @media (max-width: 1000px) {
    max-width: 100%;
  }

  h3 {
    padding: 5px 0;
    color: ${(props) => props.theme.colors.headingLight};
    font-size: 1.6rem;
    font-weight: 500;
  }

  span {
    color: ${(props) => props.theme.colors.bodyLight};
    font-size: 1.6rem;
  }
`;

export const PriceInfoContent = styled.div`
  display: flex;
  width: 100%;
  max-width: 500px;
  justify-content: space-between;
  align-items: center;

  :has(> .total) {
    padding-top: 16px;
    margin-top: 12px;
    border-top: solid 1px ${(props) => props.theme.colors.neutral100};
  }

  @media (max-width: 900px) {
    max-width: 100%;
    padding: 0px;
  }

  span.price-value {
    padding: 8px 0;
    font-family: 'DM Sans', system-ui, sans-serif;
    font-size: 16px;
    color: ${(props) => props.theme.colors.neutral900};
    font-weight: 700;
  }

  span.price-description {
    padding: 8px 0;
    font-family: 'DM Sans', system-ui, sans-serif;
    color: ${(props) => props.theme.colors.neutral600};
    font-size: 16px;
    font-weight: 500;
  }

  /* Descontos em verde; o da forma de pagamento (Pix) com a descrição também */
  &.discount span.price-value,
  span.coupon-discount,
  &.payment-discount span {
    color: ${(props) => props.theme.colors.success};
  }

  span.total {
    font-family: 'Sora', system-ui, sans-serif;
    font-weight: 700;
    font-size: 22px;
    color: ${(props) => props.theme.colors.neutral900};
  }

  /* Taxa é custo, não erro: cor normal; riscada (frete grátis) em cinza. */
  &.delivery-fee {
    span.price-value {
      color: ${props => props.theme.colors.neutral900};
    }

    span.price-value span {
      color: ${props => props.theme.colors.neutral400};
    }
  }
`;

export const ButtonFooterWrap = styled.button`
  height: 52px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
  width: 100%;
  color: ${(props) => props.theme.colors.white};
  background: ${(props) => props.theme.colors.primary};
  font-size: 1.6rem;
  font-weight: 700;
  border-radius: 999px;
  font-family: 'DM Sans', system-ui, sans-serif;
  border: none;
  transition: background 200ms ease;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: ${(props) => darken(0.08, props.theme.colors.primary)};
  }

  :disabled {
    background: var(--neutral-200, #D0D1D3);
    color: var(--neutral-800, #44474E);
    cursor: not-allowed;
  }

  > div {
    margin-top: 5px;
    margin-right: 12px;
  }

  span {
    font-weight: 500;
    margin-left: 5px;
  }

  @media (max-width: 900px) {
    max-width: 100%;
  }
`;

export const RadioSelectPayment = styled.div`
  display: flex;
  gap: 10px;
  padding: 2px 4px;
  align-items: center;

  .labelDiscount {
    background-color: ${(props) => props.theme.colors.alertsuccess};
    border-radius: 999px;
    padding: 2px 10px;
    color: #fff;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    }
`;

export const StyledCouponInput = styled(InputCustom)`
  width: 100%;
  max-width: 280px;
  align-self: normal;
  .redFont{
        color: ${props => props.theme.colors.error};
    }
`;

// Pagamento online abaixo do piso do provedor (decisão 0017): orientação, sem vermelho
export const OnlinePaymentMinimumNote = styled.p`
  margin: 8px 0;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  color: ${props => props.theme.colors.neutral900};
  background: ${props => props.theme.colors.neutral50};
`;
